import React from "react";
import { Link } from "react-router-dom";
import { SingleCardPage } from "components/ui/SingleCardPage";
import { EditUserAuthCard } from "components/cards/UserAuths/EditUserAuthCard";
import { ErrorBoundary } from "components/ui/ErrorBoundary";
import { RequireSuperuser } from "components/auth/RequireSuperuser";

export function EditUserAuthPage() {
  return (
    <RequireSuperuser>
      <SingleCardPage
        title="Edit User Auth"
        header={
          <>
            <Link to="/user_auths">User Auths</Link> &raquo; Edit User Auth
          </>
        }
      >
        <ErrorBoundary title="Edit User Auth">
          <EditUserAuthCard />
        </ErrorBoundary>
      </SingleCardPage>
    </RequireSuperuser>
  );
}
EditUserAuthPage.displayName = "EditUserAuthPage";
